import React from 'react';
import AdditionalDocsTreeViewLabel, {
    IAdditionalDocsTreeViewLabelProps,
} from './AdditionalDocsTreeViewLabel';
import { Box, Stack } from '@mui/material';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { IAppReduxStore } from '../../../redux/store';
import { TreeItemContentProps, useTreeItemState } from '@mui/x-tree-view';

/**
 * ContentComponent for the TreeItem that allows limiting expansion to clicking the icon.
 */
export const CustomTreeLeaf = (additionalLabelProps: IAdditionalDocsTreeViewLabelProps) =>
    React.forwardRef(function (props: TreeItemContentProps, ref) {
        /** Deconstruct props. */
        const { classes, className, itemId, icon: iconProp, expansionIcon, displayIcon } = props;
        const { doc, mainDoc, small, disableClick, hasChildren } = additionalLabelProps;

        /** Get relevant values from Redux store. */
        const targetDocId = useSelector(
            (store: IAppReduxStore) => store.projectSidepanel.targetDocId,
        );

        /** Hook for expansion. */
        const { expanded, handleExpansion } = useTreeItemState(itemId);

        const icon = iconProp || expansionIcon || displayIcon;

        /**
         * Handles the expansion for the Treeview Component only by click the icon.
         */
        const handleExpansionClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
            handleExpansion(event);
        };

        return (
            <Stack
                className={clsx(className, classes.root, {
                    [classes.expanded]: expanded,
                    [classes.selected]: doc.UniversalID === targetDocId,
                })}
                direction='row'
                ref={ref as React.Ref<HTMLDivElement>}
                sx={{
                    paddingLeft: 1,
                    alignItems: 'center',
                }}
            >
                <Box
                    sx={{
                        width: hasChildren || !small ? '26px' : 'unset',
                        py: 1,
                        position: 'relative',
                        left: !small ? '22px' : 'unset',
                        right: small ? '5px' : 'unset',
                        cursor: 'pointer',
                    }}
                    onClick={handleExpansionClick}
                >
                    {icon}
                </Box>
                <AdditionalDocsTreeViewLabel
                    doc={doc}
                    mainDoc={mainDoc}
                    small={small}
                    disableClick={disableClick}
                />
            </Stack>
        );
    });
